/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Validation_Group_RequiredInputs */

const en_users_validation_group_required = /** @type {(inputs: Users_Validation_Group_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User group is required`)
};

const pt_br2_users_validation_group_required = /** @type {(inputs: Users_Validation_Group_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo do usuário é obrigatório`)
};

/**
* | output |
* | --- |
* | "User group is required" |
*
* @param {Users_Validation_Group_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_validation_group_required = /** @type {((inputs?: Users_Validation_Group_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Validation_Group_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_validation_group_required(inputs)
	return pt_br2_users_validation_group_required(inputs)
});